import s2_bg from '../../../assets/images/s2_bg.png';
import right_arrow from '../../../assets/images/right_arrow.png';
import React, { useEffect, useState } from 'react';
import AOS from 'aos';

export default function Section2() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });

    setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    AOS.refresh();
  }, []);

  return (
    <>
      <div className="sect2 " style={{ backgroundImage: `url(${s2_bg})` }}>
        <div className="center">
          <div className="row-flex s2_content pt-13">
            <div className="s2_content_left w-50 m-none"></div>
            <div className="s2_content_right w-50 m-w-100">
              <div className="col-flex txt-left gap-20">
                <p
                  className="prt-medium fs-20 fc-005eed"
                  data-aos="fade-up"
                  data-aos-delay=""
                >
                  Global Network
                </p>
                <p
                  className="prt-bold fs-50 fc-black1 lh-60px"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  글로벌 자율주행 <br />
                  배송로봇 선도기업
                </p>
                <div
                  data-aos="fade-up"
                  data-aos-delay="400"
                  className="prt-medium fs-20 fc-black1 row-flex-center gap-10 mb-3"
                >
                  <a href="/sub1_1">더보기</a>
                  <img src={right_arrow} alt="" />
                </div>
                <div
                  className="row-flex-center between w-65 m-w-85 t-w-85"
                  data-aos="fade-up"
                  data-aos-delay="600"
                >
                  <div className="s2_content_right_inner w-48  
                  col-flex justify-end align-end">
                    <p className="prt-light fs-20 fc-white w-100 mb-10 lh-13">
                      전세계
                      <br />
                      판매대수
                    </p>
                    <div className="">
                      <p className="prt-bold fs-40 fc-white">10만+</p>
                    </div>
                  </div>
                  <div className="s2_content_right_inner w-48  
                  col-flex justify-end align-end">
                    <p className="prt-light fs-20 fc-white w-100 mb-10 lh-13">
                      로봇 총 <br />
                      서비스 횟수
                    </p>
                    <div className="">
                      <p className="prt-bold fs-40 fc-white">8.3억+</p>
                    </div>
                  </div>
                </div>

                <div
                  data-aos="fade-up"
                  data-aos-delay="800"
                  className="gradient_box1 flex-center 
                w-65 m-w-85 t-w-85"
                >
                  <span className="prt-medium fs-25 fc-black1
                   row-flex-center ws-nowrap">
                    판매 국가 및 지역
                    <span className="prt-bold fs-60 fc-005eed 
                     pl-10">60+</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
